import React from 'react';

import TreatmentFilter from '../TreatmentFilter/TreatmentFilter';
import TreatmentSort from '../TreatmentSort/TreatmentSort';

interface Props {
    className?: string;
}

const SortAndFilterActions = ({ className = '' }: Props) => (
    <div className={`flex justify-between gap-100 ${className}`}>
        <div className="w-full md:w-auto">
            <TreatmentFilter className="w-full" />
        </div>
        <div className="w-full md:w-auto">
            <TreatmentSort className="w-full" />
        </div>
    </div>
);

export default SortAndFilterActions;
